(() => {
  'use strict';

  if (document.documentElement.lang.split('-')[0].toLowerCase() !== 'ar' || window.__aoArabicGalleryStatusReady) return;
  window.__aoArabicGalleryStatusReady = true;

  const bindGalleryAnnouncements = () => {
    document.querySelectorAll('[data-aocdx-gallery-status]').forEach((status) => {
      const localize = () => {
        const match = /^Image (\d+) of (\d+)$/.exec(status.textContent);
        if (match) status.textContent = `صورة ${match[1]} من ${match[2]}`;
      };
      const observer = new MutationObserver(localize);
      observer.observe(status, { childList: true, characterData: true, subtree: true });
      localize();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindGalleryAnnouncements, { once: true });
  } else {
    bindGalleryAnnouncements();
  }
})();
